
import "../../../styles/forms.css";


import { Dynamic } from "../../../controllers/conductor";
import { getController } from "../../../controllers/getter";
import { MainWindow } from "../MainWindow";

import { IconButton } from "../../widgets/buttons";
import { getCurrentMonth, getMonthName } from "../../../misc/date";
import { ScrollingTable } from "../../widgets/table";


import React from "react";
import { Blocker } from "../../widgets/misc";
import { AlertDrawer } from "../../sections/sidebar/AlertDrawer";
import { MonthYearSelector } from "../../widgets/date_selector";
import { LoadingAnimation } from "../../widgets/loading";
import { ProvinceListController } from "../../../controllers/generic/ProvinceList";



function ProvinceList({ args }) {
    const { month, year } = getCurrentMonth();
    const { title, itemRedirect = () => {} } = args;

    const ref = { month, year };

    const controller = getController(ProvinceListController, { ref, title, itemRedirect});
    const { notifiers, status } = controller;
    
    return (<MainWindow currentTab="forms" subtab="sameday">
        <Dynamic conductor={[ notifiers.ready, notifiers.unauthorized ]} child={()=>
            status.unauthorized ? <Unauthorized /> : status.ready ? <Main details={{ title, itemRedirect }} controller={controller} /> : <LoadingWindow />
        } />
    </MainWindow>);
}

function Unauthorized() {
    return <div>Unauthorized</div>;
}

function LoadingWindow() {
    return (<center><LoadingAnimation /> Loading...</center>);
}


function Main({ controller, details }) {
    return <div className="form-main">
        <div className="alert-drawer-wrapper"><AlertDrawer controller={controller.notifiers.alert} /></div>
        <Header controller={controller} details={details} />
        <ListSection controller={controller} details={details} />
        <Footer controller={controller} details={details} />
    </div>;
}


function Header({ controller, details: { title } }) {
    const { notifiers } = controller;

    const onDateChange = ({ month, year }) => controller.changeDate(month, year);

    return <Dynamic conductor={notifiers.reloaded} child={()=>{
        const { month, year } = controller.reference;
        const date = getMonthName(month) + " " + year;

        return <header>
            <div>
                <h2>{title}</h2>
                <h5>{ ` ${date}` }</h5>
            </div>
            <div className="buttons">
                <IconButton icon="refresh" onClick={() => controller.refresh()} />
                <MonthYearSelector month={month} year={year} onChange={onDateChange} />
            </div>
        </header>;
    }} />;
}



function ListSection({ controller }) {
    const columns = [
        { title: "PROVINCE", width: "100%" }
    ];

    const { notifiers, status } = controller;

    return <main>
        <Dynamic conductor={notifiers.reloaded} child={()=>{
            const { data } = controller;

            const rows = data.map((province) => [ province.name ]);

            const onRowClick = (rowIndex) => {
                const province = data[rowIndex];
                controller.redirectItem(province.id);
            };

            return <ScrollingTable columns={columns} rows={rows} onRowClick={onRowClick} />;
        }} />
        <Dynamic conductor={notifiers.reloading} child={()=>
            <Blocker active={status.reloading}><center><LoadingAnimation />Loading data...</center></Blocker>
        } />
    </main>
}

function Footer({ controller }) {
    return <footer></footer>;
}



export default ProvinceList;